import React, { useContext } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Person as PersonIcon, Close as CloseIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { PriceContext } from '../pages/PriceContextOptimized';
import { useCustomer } from '../pages/CustomerContext';

const ActingAsIndicator = () => {
  const navigate = useNavigate();
  const { resetForNewCustomer } = useContext(PriceContext);
  const { clearCustomer } = useCustomer();

  const actingAsData = JSON.parse(localStorage.getItem('actingAsCustomer') || 'null');
  if (!actingAsData) return null;

  const handleStopActingAs = () => {
    localStorage.removeItem('actingAsCustomer');
    localStorage.removeItem('customerId');
    localStorage.removeItem('priceData');
    localStorage.setItem('hydrated', 'false');
    clearCustomer?.();
    resetForNewCustomer?.();
    navigate('/staff/sales-dashboard');
  };
  
  return (
    <Box
      sx={{
        backgroundColor: '#ff9800',
        color: 'white',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <PersonIcon />
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        Acting as Customer: <strong>{actingAsData.customerIdDisplay || actingAsData.email}</strong>
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={<CloseIcon />}
        onClick={handleStopActingAs}
        sx={{
          backgroundColor: 'white',
          color: '#ff9800',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
          fontWeight: 600,
          textTransform: 'none',
        }}
      >
        Stop Acting As
      </Button>
    </Box>
  );
};

export default ActingAsIndicator;